import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  ListChecks,
  Settings,
  BarChart2,
  FileText,
  CreditCard,
  LogOut
} from 'lucide-react';

export const AdminSidebar = () => (
  <aside className="bg-gray-900 text-white w-64 min-h-screen flex flex-col border-r border-gray-800">
    <div className="p-6 text-2xl font-bold border-b border-gray-800">OpsQuest Admin</div>
    <nav className="flex-1 p-4 space-y-2">
      <NavLink to="/admin" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`} end>
        <LayoutDashboard className="w-5 h-5 mr-3" /> Dashboard
      </NavLink>
      <NavLink to="/admin/users" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <Users className="w-5 h-5 mr-3" /> User Management
      </NavLink>
      <NavLink to="/admin/challenges" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <ListChecks className="w-5 h-5 mr-3" /> Challenge Management
      </NavLink>
      <NavLink to="/admin/settings" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <Settings className="w-5 h-5 mr-3" /> System Settings
      </NavLink>
      <NavLink to="/admin/analytics" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <BarChart2 className="w-5 h-5 mr-3" /> Analytics
      </NavLink>
      <NavLink to="/admin/audit-logs" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <FileText className="w-5 h-5 mr-3" /> Audit Logs
      </NavLink>
      <NavLink to="/admin/billing" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <CreditCard className="w-5 h-5 mr-3" /> Billing
      </NavLink>
      <NavLink to="/admin/community" className={({ isActive }) => `flex items-center px-4 py-2 rounded-lg font-medium transition-all duration-200 ${isActive ? 'bg-blue-700 text-white' : 'hover:bg-gray-800/70 text-gray-300'}`}> 
        <Users className="w-5 h-5 mr-3" /> Community
      </NavLink>
    </nav>
    <div className="p-4 border-t border-gray-800">
      <button className="w-full flex items-center justify-center text-red-400 hover:text-red-600">
        <LogOut className="w-5 h-5 mr-2" /> Logout
      </button>
    </div>
  </aside>
); 